// default
export const COMMON = 'common';
export const COMMON_SLICE_NAME = `${COMMON}Slice`;
